import { Grid } from "../core/components/grid.js";
import { General } from "../../siteManagement/general.js";
import {
    ResourcePlanningSchedulerActions,
    ResourcePlanningSchedulerDataViewModel,
    ResourcePlanningSchedulerEventViewModel
} from "./resourcePlanningScheduler.js";
import { JourneyLegKind, Scheduler } from "./scheduler.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { SimpleCheckBox } from "../core/components/simpleCheckBox.js";
import { Util } from "./utils.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { Helper } from "../core/util/helper.js";
import { DatePicker } from "../core/components/datePicker.js";
import { ResourcePlanningHelper } from "../core/util/resourcePlanningHelper.js";
import { Sheet } from "../../siteManagement/sheet.js";
import { Button } from "../core/components/button.js";
import { ConnectedWindow } from "../core/components/connectedWindow.js"
import { ToggleButtonGroup } from "../core/components/toggleButtonGroup.js";
import { ToggleButton } from "../core/components/toggleButton.js";
import { ConsiderGeoMode, ConsiderSkillMode, ResourceWithSlots } from "./capacityDiagram.js";
import { AppHelper } from "../appHelper.js";
import { JourneyHelper } from "../core/util/journeyHelper.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react"

export class WorkList extends React.Component<WorkListProps, WorkListState> {
    public _grid: Grid;
    public _preselectFilter = null;

    public _gridSlot: Grid;

    public _factory = ComponentHelper.createFactory();

    public worklistSheet: Sheet;
    //public openWorklistInWindow: boolean;


    constructor(props: WorkListProps) {
        super(props);
        this.state = {
            //interactiveSlotMode: false,
            slotStartDate: Helper.dates.removeTime(new Date()),
            //selectedDataItemId: null,
            showSlotsGrid: false
        };
        const markedEvent = props.scheduler !== null ? props.scheduler.getMarkedEvent() : null;
        if (markedEvent !== null && markedEvent.ResourceId.indexOf("g|") == 0) {
            this._preselectFilter = markedEvent.Projnr + "/" + markedEvent.Pindex;
        }
        this.worklistSheet = General.Sheet.Manager.getTopMostVisibleSheet();
    }

    refreshGrids = () => {
        if (this._grid)
            this._grid.getGridRef().refresh();
        if (this._gridSlot)
            this._gridSlot.getGridRef().refresh();
    }

    public _getDatePickerProps = () => {
        const min: Date = this._getEarliestStartAsPossible();
        const max: Date = Helper.dates.toDate(this.props.data.SettingsPlanningBoard.End);
        let props = this._factory.getDefaultDatePickerProps();
        props.value = this.state.slotStartDate;
        if (min.getTime() < max.getTime()) {
            props.field.min = min;
            props.field.max = max;
        }
        props.onChange = (_, value) => {
            this._setStartDate(Helper.dates.toDate(value));
        }
        return props;
    }

    private _setStartDate = (value: Date) => {
        value = (value || new Date());
        value = Helper.dates.removeTime(value);
        const start: Date = this._getEarliestStartAsPossible();
        const end: Date = Helper.dates.removeTime(Helper.dates.toDate(this.props.data.SettingsPlanningBoard.End));
        if ((start.getTime() > value.getTime()) || (value.getTime() > end.getTime())) {
            value = start;
        }
        this.setState({ slotStartDate: value }, () => {
            this.props.actions.slotWorkListChanged();
        })
    }

    public handleInteractiveModeCheckStateChanged = (checked: boolean) => {
        this.props.actions.toggleInteractiveSlotMode(checked);
    }

    public handleShowSlot = (value: boolean) => {
        this.setState({ showSlotsGrid: value });
    }

    componentDidMount() {
        this.props.gridSlotOptions.columns.find((x: { field: string; }) => x.field == "slot_skillsNumber").hidden = !this.props.skillsEnabled;
    }

    componentDidUpdate() {
        this._sanitizeStartDate();
    }

    private _sanitizeStartDate = () => {
        const value = Helper.dates.removeTime(this.state.slotStartDate);
        const start: Date = this._getEarliestStartAsPossible();
        const end: Date = Helper.dates.removeTime(Helper.dates.toDate(this.props.data.SettingsPlanningBoard.End));
        if (!this._RPInPast() && ((start.getTime() > value.getTime()) || (value.getTime() > end.getTime()))) {
            this._setStartDate(start);
        }
    }

    private _getEarliestStartAsPossible = () => {
        let value = Helper.dates.toDate(this.props.data.SettingsPlanningBoard.Start);
        if (value.getTime() < new Date().getTime()) {
            value = new Date();
        }
        return Helper.dates.removeTime(value);
    }

    private _RPInPast = () => {
        const now: Date = Helper.dates.removeTime(new Date());
        const start: Date = Helper.dates.removeTime(Helper.dates.toDate(this.props.data.SettingsPlanningBoard.End));
        const end: Date = Helper.dates.removeTime(Helper.dates.toDate(this.props.data.SettingsPlanningBoard.End));
        return start.getTime() < now.getTime() && end.getTime() < now.getTime();
    }

    // Start api
    selectRow = (eventId: string, scroll: boolean = false) => {
        this._grid.selectRow(eventId.replace("|", "/"));
        if (scroll)
            this._grid.getGridRef().content.scrollTop(this._grid.getGridRef().select().position().top);
    }
    // End api
    public _getSlotGridData = () => {
        const res: Array<GridSlotData> = [];
        let data = this.props.currentSlots;
        if (!data || data.length == 0)
            return res;

        data.forEach(d => {
            if (d.slots.length > 0) {
                const ressFound
                    = this.props.data.Resources.filter(x => x.Id == d.id);
                if (ressFound.length > 0) {
                    d.slots.forEach(s => {

                        let skillsPercent = 0;
                        if (this.props.slotSettings.considerSkills == ConsiderSkillMode.Fuzzy) {
                            skillsPercent = 100;
                            if (s.skillsRequired != 0) {
                                skillsPercent = (s.skillsProvided * 100 / s.skillsRequired);
                            }
                        }

                        const item: GridSlotData = {
                            id: d.id,
                            name: d.name,
                            ressNr: d.ressNr,
                            slot_id: s.id,
                            slot_startDate: s.startDate,
                            slot_endDate: s.endDate,
                            slot_skillsNumber: skillsPercent,
                            slot_skills: this.props.slotSettings.considerSkills == ConsiderSkillMode.Fuzzy ? skillsPercent + "% (" + s.skillsProvided + "/" + s.skillsRequired + ")"
                                : "",
                            slot_wayThereNumber: s.wayThere.Kind == JourneyLegKind.NoGeoData ? 99999 : s.wayThere.DistanceKm,
                            slot_wayThere: JourneyHelper.getJourneyLegText(s.wayThere, "none", false),
                            slot_wayBackNumber: s.wayBack.Kind == JourneyLegKind.NoGeoData ? 99999 : s.wayBack.DistanceKm,
                            slot_wayBack: JourneyHelper.getJourneyLegText(s.wayBack, "none", false),
                            priority: "n/a",
                            arbeitsBeginn: s.assignmentTimes.arbeitsBeginn,
                            arbeitsEnde: s.assignmentTimes.arbeitsEnde,
                            endeIst: s.assignmentTimes.endeIst,
                            startIst: s.assignmentTimes.startIst
                        };
                        res.push(item);
                    })
                }
            }
        });

        return res;
    }
    public _getGridData = () => {
        let data = this.props.data.Events.filter(x => x.ResourceId.indexOf("g|") == 0);
        data = data.sort((a: ResourcePlanningSchedulerEventViewModel, b: ResourcePlanningSchedulerEventViewModel) => {
            //Level 1 nach Prioritaet sotiert
            let value_a: number = Helper.getValueOrDefault(a.Prioritaet, -9999);
            let value_b: number = Helper.getValueOrDefault(b.Prioritaet, -9999);
            if (value_a < value_b) {
                return 1;
            } else if (value_a > value_b) {
                return -1;
            } else {
                //Level 2 nach Start sotiert
                value_a = Helper.dates.toDate(a.Start).getTime();
                value_b = Helper.dates.toDate(b.Start).getTime();
                if (value_a < value_b) {
                    return -1;
                } else if (value_a > value_b) {
                    return 1;
                } else {
                    //Level 3 nach End sotiert
                    value_a = Helper.dates.toDate(a.End).getTime();
                    value_b = Helper.dates.toDate(b.End).getTime();
                    if (value_a < value_b) {
                        return -1;
                    } else if (value_a > value_b) {
                        return 1;
                    }
                }
            }
            return 0;
        })
        return data;
    }

    public onRowDataBound = (e: HTMLElement, dataItem: ResourcePlanningSchedulerEventViewModel) => {
        if (this.props.interactiveSlotMode) {
            const id = dataItem.Projnr + "|" + dataItem.Pindex;
            ResourcePlanningHelper.makeDraggableForSlots(e, dataItem, () => this.canDrag(id));
        } else if (!this.props.openWorklistInWindow) {
            ResourcePlanningHelper.makeDraggableForScheduler(e, dataItem);
        }
        else {
            ResourcePlanningHelper.makeDraggableForDay(e, dataItem, () => true);
        }
        e.onclick = (ev) => this.handleOnClick(ev, dataItem);
    }

    public onSlotRowDataBound = (e: HTMLElement, dataItem: GridSlotData) => {
        e.onclick = (ev) => this.handleSlotOnClick(ev, dataItem);
    }

    private handleOnClick = (ev: MouseEvent, dataItem: ResourcePlanningSchedulerEventViewModel) => {
        const $target = $(ev.target);
        if ($target.data("delegation-link") !== undefined && $target.data("id") !== undefined && 
            $target.data("id2") !== undefined) {
            this.props.actions.focusEvent($target.data("id"));
            this.props.actions.openEvent($target.data("id"), $target.data("id2"));
        } else if ($target.data("address-link") !== undefined && $target.data("id") !== undefined) {
            const url = "Address/Edit?isWindow=true&id=" + encodeURIComponent($target.data("id"));
            General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        } else {
            let $a = $target.closest("a");
            if ($a == undefined)
                return;
            if ($a.data("id") !== undefined && $a.data("jump-to-assignment-link") !== undefined) {
                this.props.actions.focusEvent($a.data("id"));
            } else {
                this.props.actions.markEvent(dataItem.Id);
            }
        }
    }

    private handleSlotOnClick = (ev: MouseEvent, _: GridSlotData) => {
        //console.log("handleSlotOnClick: ", ev, dataItem);
        const $target = $(ev.target);
        let $a = $target.closest("a");
        if ($a == undefined)
            return;
        if ($a.data("id") !== undefined && $a.data("jump-to-slot-link") !== undefined) {
            this.props.actions.focusSlotEvent($a.data("id"));
        }
    }

    private canDrag = (id: string) => {
        return this.props.selectedAssignmentForSlotId == id;
    }

    render() {
        return this.props.openWorklistInWindow
            ? <ConnectedWindow parent={this} parentSheet={this.worklistSheet} openAsPopUp={false} moduleName="app/resourcePlanningScheduler/workList" className="UnDockedWorkGridListUi" onClose={() => { this.props.onOpenInWindow(false); }} />
            : <div className="flex-container__item resource-planning-container__work-list">< WorkGridListUi parent={this}></WorkGridListUi></div>
    }
}

class WorkGridListUi extends React.Component<{ parent: WorkList }, any>{
    common = new AppHelper();
    private handleUpdateSettings(name: string, value: any) {
        let settings = this.props.parent.props.slotSettings;

        if (name == "Flags")
            settings.considerFlags = value;
        if (name == "Group")
            settings.considerGroup = value;
        if (name == "MainGroup")
            settings.considerMainGroup = value;
        if (name == "Skills")
            settings.considerSkills = value;
        if (name == "Geo")
            settings.considerGeo = value;
        if (name == "Filter")
            settings.slotRespectSlotResourceFilter = value;
        if (name == "Debug")
            settings.slotEnableDebugMode = value;
        if (name == "Sla")
            settings.considerSla = value;

        this.props.parent.props.actions.updateSlotSettings(settings);
    }

    render() {
        const checkBoxDisabled =
            (this.props.parent.props.readonly ||
                (!Util.isTodayInSchedulerTimerange(this.props.parent.props.data.SettingsPlanningBoard) &&
                    !Util.IsSchedulerTimerangeInTheFuture(this.props.parent.props.data.SettingsPlanningBoard))) &&
            !this.props.parent.props.interactiveSlotMode;

        // @ts-ignore
        const labelStyle: React.CSSProperties = {
            minWidth: "fit-content"
        }

        // @ts-ignore
        const checkStyle: React.CSSProperties = {
            minWidth: "20px"
        }


        const checkBox = (
            <>
                <SimpleCheckBox
                    label={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.InteractiveSlotSearch"]}
                    onChange={this.props.parent.handleInteractiveModeCheckStateChanged}
                    value={this.props.parent.props.interactiveSlotMode}
                    disabled={checkBoxDisabled}
                    labelStyle={labelStyle}
                    inputStyle={checkStyle}
                />
            </>
        );
        const datePicker = (
            <div style={{ display: this.props.parent.props.interactiveSlotMode ? "flex" : "none", alignItems: "center", marginLeft: "22px" }}>
                <label>{this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.MinStart"]}</label>
                <div style={{ marginLeft: "5px", maxWidth: "140px" }}>
                    <DatePicker {...this.props.parent._getDatePickerProps()} />
                </div>
            </div>
        );

        // @ts-ignore
        const buttonGroupStyle: React.CSSProperties = {
            marginLeft: "10px",
            display: this.props.parent.props.interactiveSlotMode ? "flex" : "none"
        };

        // @ts-ignore
        const buttonSkillsGroupStyle: React.CSSProperties = {
            marginLeft: "10px",
            display: this.props.parent.props.interactiveSlotMode && this.props.parent.props.skillsEnabled ? "flex" : "none"
        };
        
        const toggleFlags = this.props.parent.props.flagsEnabled ? <ToggleButton
                title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderFlags"]}
                initialValue={this.props.parent.props.slotSettings.considerFlags}
                value={this.props.parent.props.slotSettings.considerFlags}
                handleToggle={(value) => { this.handleUpdateSettings("Flags", value); }}
                iconName={"flag"} /> : null;

        const toggleGroup = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderGroup"]}
            initialValue={this.props.parent.props.slotSettings.considerGroup}
            value={this.props.parent.props.slotSettings.considerGroup}
            handleToggle={(value) => { this.handleUpdateSettings("Group", value); }}
            iconName={"user-group"} />;

        const toggleMainGroup = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderMainGroup"]}
            initialValue={this.props.parent.props.slotSettings.considerMainGroup}
            value={this.props.parent.props.slotSettings.considerMainGroup}
            handleToggle={(value) => { this.handleUpdateSettings("MainGroup", value); }}
            iconName={"users-between-lines"} />;

        //<Button handleClick={this._navigatePrevCustom} layerIcons={[{ name: "arrow-left" }, { name: this._prevCustomDiff.toString(), isText: true, style: { fontSize: "0.7em", position: "absolute", top: "25%" } }]} readOnly={this.props.disabled} title={buttonTitles[1]} buttonStyle={{ width: "32px" }} iconStyle={{ display: "flex" }} />
        const toggleSkillsOff = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderSkillsOff"]}
            initialValue={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Off}
            value={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Off}
            readOnly={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Off}
            handleToggle={(_) => {
                this.handleUpdateSettings("Skills", ConsiderSkillMode.Off);
            }}
            layerIcons={[
                { name: "user-graduate" },
                { name: "ban fa-solid", style: { fontSize: "0.5em", transform: "translate(0px,5px)" } }
            ]}
            isInGroup={true}
        />;

        const toggleSkillsFuzzy = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderSkillsFuzzy"]}
            initialValue={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Fuzzy}
            value={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Fuzzy}
            readOnly={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Fuzzy}
            handleToggle={(_) => {
                this.handleUpdateSettings("Skills", ConsiderSkillMode.Fuzzy);
            }}
            layerIcons={[
                { name: "user-graduate" },
                { name: "≈", isText: true, style: { position: "relative", top: "25%" } }
            ]}
            isInGroup={true}
        />;

        const toggleSkillsExact = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderSkillsExact"]}
            initialValue={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Exact}
            value={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Exact}
            readOnly={this.props.parent.props.slotSettings.considerSkills == ConsiderSkillMode.Exact}
            handleToggle={(_) => {
                this.handleUpdateSettings("Skills", ConsiderSkillMode.Exact);
            }}
            layerIcons={[
                { name: "user-graduate" },
                { name: "equals fa-solid", style: { fontSize: "0.5em", transform: "translate(0px,5px)" } }
            ]}
            isInGroup={true}
            isLastInGroup={true}
        />;

        const toggleGeoOff = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderGeoOff"]}
            initialValue={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Off}
            value={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Off}
            readOnly={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Off}
            handleToggle={(_) => {
                this.handleUpdateSettings("Geo", ConsiderGeoMode.Off);
            }}

            layerIcons={[
                { name: "location-dot" },
                { name: "ban fa-solid", style: { fontSize: "0.5em", transform: "translate(0px,5px)" } }
            ]}
            isInGroup={true}
        />;

        const toggleGeoFuzzy = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderGeoFuzzy"]}
            initialValue={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Fuzzy}
            value={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Fuzzy}
            readOnly={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Fuzzy}
            handleToggle={(_) => {
                this.handleUpdateSettings("Geo", ConsiderGeoMode.Fuzzy);
            }}
            layerIcons={[
                { name: "location-dot" },
                { name: "≈", isText: true, style: { position: "relative", top: "25%" } }
            ]}

            isInGroup={true}
        />;

        const toggleGeoExact = <ToggleButton
            title={this.props.parent.props.translations["WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ConsiderGeoExact"]}
            initialValue={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Exact}
            value={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Exact}
            readOnly={this.props.parent.props.slotSettings.considerGeo == ConsiderGeoMode.Exact}
            handleToggle={(_) => {
                this.handleUpdateSettings("Geo", ConsiderGeoMode.Exact);
            }}
            layerIcons={[
                { name: "location-dot" },
                { name: "equals fa-solid", style: { fontSize: "0.5em", transform: "translate(0px,5px)" } }
            ]}
            isInGroup={true}
            isLastInGroup={true}
        />;
        
        const toggleSLA = this.props.parent.props.slaEnabled ? <ToggleButton
                title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ConsiderSla")}
                initialValue={this.props.parent.props.slotSettings.considerSla}
                value={this.props.parent.props.slotSettings.considerSla}
                handleToggle={(value) => { this.handleUpdateSettings("Sla", value); }}
                iconName={"file-contract"} /> : null;

        const toggleResourceFilter = <ToggleButton
            title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.RespectSlotResourceFilter")}
            initialValue={this.props.parent.props.slotSettings.slotRespectSlotResourceFilter}
            value={this.props.parent.props.slotSettings.slotRespectSlotResourceFilter}
            handleToggle={(value) => { this.handleUpdateSettings("Filter", value); }}
            iconName={"person"} />;

        const toggleDebugMode = <ToggleButton
            title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.DebugMode")}
            initialValue={this.props.parent.props.slotSettings.slotEnableDebugMode}
            value={this.props.parent.props.slotSettings.slotEnableDebugMode}
            handleToggle={(value) => { this.handleUpdateSettings("Debug", value); }}
            iconName={"screwdriver-wrench"} />;


        const id = this.props.parent.props.selectedAssignmentForSlotId;
        let idSelectedText = null;
        if (id != null)
            idSelectedText = Helper.getTranslation("WebSMS.SlotPlanning.JumpToAssignment") + ": " + id.replace("|", "/");

        const buttonFocus = (
            <Button
                title={idSelectedText}
                handleClick={() => this.props.parent.selectRow(id, true)}
                iconName="bullseye-pointer"
                readOnly={id == null || this.props.parent.state.showSlotsGrid}
            />
        );

        const buttonShowSlotGrid = (
            <ToggleButton
                title={Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.ShowSlotsResults")}
                initialValue={this.props.parent.state.showSlotsGrid}
                value={this.props.parent.state.showSlotsGrid}
                handleToggle={(value) => { this.props.parent.handleShowSlot(value) }}
                iconName={"traffic-light"}
                readOnly={id == null} />
        );

        const buttonOpenInWindow = (
            <div style={{ marginLeft: "auto", marginRight: "11px" }}>
                <Button buttonStyle={{ borderRadius: "var(--border-radius)" }} title={Helper.getTranslation("Einsatz.Ausdocken")} handleClick={() => this.props.parent.props.onOpenInWindow(true)} iconName="table"></Button>
            </div>
        );

        const grid = (
            <Grid
                ref={(r) => { this.props.parent._grid = r }}
                id="resourcePlanningWorkList"
                options={this.props.parent.props.gridOptions}
                data={this.props.parent._getGridData()}
                preselectFilter={this.props.parent._preselectFilter}
                onSelectionChanged={(dataItem: ResourcePlanningSchedulerEventViewModel) => {
                    //console.log("onSelectionChanged: ", dataItem);
                    //check internal "change" from Grid component
                    if (dataItem == null && this.constructor.name === "Grid")
                        return;

                    if (dataItem != null && this.props.parent.props.interactiveSlotMode)
                        this.props.parent.props.actions.computeSlots(dataItem.Id);

                    if (dataItem == null && id != null && this.props.parent.props.interactiveSlotMode) {
                        this.props.parent.props.unselectAssignmentForSlot();
                    }
                    return;
                }}
                rememberFilter={true}
                rememberGrouping={true}
                rememberSorting={true}
                rowDataBound={this.props.parent.onRowDataBound}
                rememberCollapsedRows={true}
            />);

        let gridSlots = null;
        if (id != null && this.props.parent.state.showSlotsGrid) {
            gridSlots = (<Grid
                ref={(r) => { this.props.parent._gridSlot = r }}
                id="slotPlanningWorkList"
                options={this.props.parent.props.gridSlotOptions}
                data={this.props.parent._getSlotGridData()}
                rememberFilter={true}
                rememberGrouping={true}
                rememberCollapsedRows={true}
                rememberSorting={true}
                rowDataBound={this.props.parent.onSlotRowDataBound}
            />)
        }

        return (
            <FullHeightContainer>
                <div style={{ padding: "6px", display: "flex", alignItems: "center", minHeight: "43px" }}>
                    {checkBox}
                    {datePicker}
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {buttonFocus}
                    </ToggleButtonGroup>
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {buttonShowSlotGrid}
                    </ToggleButtonGroup>
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {toggleFlags}
                        {toggleMainGroup}
                        {toggleGroup}
                        {toggleSLA}
                    </ToggleButtonGroup>
                    <ToggleButtonGroup style={buttonSkillsGroupStyle}>
                        {toggleSkillsOff}
                        {toggleSkillsFuzzy}
                        {toggleSkillsExact}
                    </ToggleButtonGroup>
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {toggleGeoOff}
                        {toggleGeoFuzzy}
                        {toggleGeoExact}
                    </ToggleButtonGroup>
                    <ToggleButtonGroup style={buttonGroupStyle}>
                        {toggleResourceFilter}
                        {toggleDebugMode}
                    </ToggleButtonGroup>
                    {!this.props.parent.props.openWorklistInWindow ? buttonOpenInWindow : null}
                </div>
                <div style={{ display: !gridSlots ? "flex" : "none", flex: 1 }}>
                    {grid}
                </div>
                <div style={{ display: gridSlots ? "flex" : "none", flex: 1 }}>
                    {gridSlots}
                </div>
            </FullHeightContainer>
        );
    }
}



class Overlay extends React.Component<any, any>{
    render() {
        return <>
            <div style={{ position: "absolute", width: "100%", height: "100%", zIndex: 1000, backgroundColor: "lightgray", opacity: 0.5 }}></div>
        </>
    }
}

interface WorkListProps {
    translations: StringKeyDictionary<string>;
    data: ResourcePlanningSchedulerDataViewModel;
    gridOptions: any;
    actions: ResourcePlanningSchedulerActions;
    scheduler: Scheduler;
    readonly: boolean;
    openWorklistInWindow: boolean;
    onOpenInWindow: (openInWindow: boolean) => void;
    slotSettings: SlotSearchSettings;
    currentSlots: Array<ResourceWithSlots>;
    gridSlotOptions: any;
    skillsEnabled: boolean;
    flagsEnabled: boolean;
    slaEnabled: boolean;
    interactiveSlotMode: boolean;
    selectedAssignmentForSlotId: string;
    unselectAssignmentForSlot: () => void;
}

export interface SlotSearchSettings {
    considerFlags: boolean;
    considerMainGroup: boolean;
    considerGroup: boolean;
    considerSkills: ConsiderSkillMode;
    considerGeo: ConsiderGeoMode;
    considerSla: boolean;
    slotRespectSlotResourceFilter: boolean;
    slotEnableDebugMode: boolean;
}

interface WorkListState {
    slotStartDate: Date;
    openInWindow?: boolean;
    showSlotsGrid: boolean;
}

interface GridSlotData {
    //ressource
    ressNr: string;
    id: string,
    name: string,
    //slot
    slot_id: string;
    slot_startDate: Date | string;
    slot_endDate: Date | string;
    slot_wayThere: string;
    slot_wayThereNumber: number;
    slot_wayBack: string;
    slot_wayBackNumber: number;
    slot_skills: string;
    slot_skillsNumber: number;
    priority: string;
    arbeitsBeginn: Date | string;
    arbeitsEnde: Date | string;
    startIst: Date | string;
    endeIst: Date | string;
}

export class UnDockedWorkGridListUi extends React.Component<any, any>{
    render() {
        return <>{!this.props.isEnabled ? <Overlay /> : null}<div id="main"><div id="container" style={{ margin: "0px" }}><div className="sheet-wrapper"><div className="sheet"><div className="sheet__content"><div className="flex-container flex-container__item"><WorkGridListUi parent={this.props.parent} /></div></div></div></div></div></div></>;
    }
}